var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._v("\n  "+_vm._s(_vm.roleName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }